module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"low":"低","high":"高","risk":"危険度","targetRiver":"対象河川","alluvialFan":"扇状地","AreasBelowSeaLevel":"海抜0m地帯"},"en":{"low":"Low","high":"High","risk":"Risk","targetRiver":"target river","alluvialFan":"alluvial fan","AreasBelowSeaLevel":"areas below sea level"}}')
  delete Component.options._Ctor
}
